export const jwtPattern =
  /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/

export const urlPattern =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

export const jwtQueryParamPattern =
  /jwt=[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/

export const base64Pattern =
  /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

export const mosaicPhoneNumberFormat = /^\+1\d{10}$/

export const containsNumbersOrSpecialCharacters =
  /[{}*&^%$#@!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?0-9]+/

export const stateCodePattern = /^[A-Z]{2}$/

export const zipCodePattern = /^[0-9]{5}$/

export const goodleapSsnPattern = /^((\d{4})|(\d{9}))$/

export const phonePattern = /^\d{3}-\d{3}-\d{4}$/ // XXX-XXX-XXXX

export const last4SsnPattern = /^\d{4}$/

export const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

export const allNumbersPattern = /^[0-9]+$/

// https://apidocs.slfportal.com/explore/solar-api-documentation/ZG9jOjE5NzA4Njkz-sunlight-financial-regular-expressions
export const sunlightAnnualIncome = /^\d{1,9}$/

export const sunlightDateOfBirth =
  /^([12]\d{3}-(0[1-9]1[0-2])-(0[1-9][12]\d3[01]))$/

export const sunlightSsn = /^\d{9}$/

export const sunlightEmployerName =
  /^[A-Za-z0-9_!@#$%*\-'.,:;+\xC0-\xCF\xD1-\xD6\xD9-\xDD\xE0-\xEF\xF1-\xF6\xF9-\xFD]+$/

export const sunlightEmploymentMonths = /^\d{1,2}$/

export const sunlightEmploymentYears = /^\d{1,2}$/

export const sunlightJobTitle = sunlightEmployerName

export const sunlightFirstName =
  /^[A-Za-z\xC0-\xCF\xD1-\xD6\xD9-\xDD\xE0-\xEF\xF1-\xF6\xF9-\xFD]+$/

export const sunlightMiddleInitial =
  /[A-Za-z\xC0-\xCF\xD1-\xD6\xD9-\xDD\xE0-\xEF\xF1-\xF6\xF9-\xFD]+$/

export const sunlightLastName = sunlightFirstName

export const sunlightPhone = /^\d{10}$/

export const sunlightStreet =
  /^[A-Za-z0-9\xC0-\xCF\xD1-\xD6\xD9-\xDD\xE0-\xEF\xF1-\xF6\xF9-\xFD .',#()/-]+$/

export const sunlightCity = sunlightStreet

export const sunlightZipCode = /^\d{5}$/
